import React from 'react';
interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'success' | 'danger' | 'warning' | 'info' | 'outline' | 'black' | 'dark' | 'medium' | 'light';
  className?: string;
}
export function Badge({
  children,
  variant = 'default',
  className = ''
}: BadgeProps) {
  const baseClasses = 'inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium';
  const variants = {
    default: 'bg-white/10 text-growthly-text',
    success: 'bg-growthly-green/20 text-growthly-green border border-growthly-green/30',
    danger: 'bg-growthly-red/20 text-growthly-red border border-growthly-red/30',
    warning: 'bg-growthly-amber/20 text-growthly-amber border border-growthly-amber/30',
    info: 'bg-blue-500/20 text-blue-400 border border-blue-500/30',
    outline: 'border border-white/20 text-growthly-muted',
    black: 'bg-growthly-bg text-growthly-text border border-white/10',
    dark: 'bg-growthly-surface text-growthly-text border border-white/10',
    medium: 'bg-growthly-panel text-growthly-text',
    light: 'bg-white/5 text-growthly-text'
  };
  return <span className={`${baseClasses} ${variants[variant]} ${className}`} data-id="element-560">
      {children}
    </span>;
}
export function StateBadge({
  state,
  className = ''
}: {
  state: string;
  className?: string;
}) {
  let variant: BadgeProps['variant'] = 'default';
  switch (state) {
    case 'LeadCualificado':
    case 'Entregado':
      variant = 'success';
      break;
    case 'Rechazado':
      variant = 'danger';
      break;
    case 'Micro-acuerdo':
    case 'EnviadoPropuesta':
      variant = 'warning';
      break;
    case 'Conversación':
      variant = 'medium';
      break;
    case 'Contactado':
      variant = 'outline';
      break;
    case 'Nuevo':
    case 'Nutrición_T+30':
    case 'Onboarding':
    default:
      variant = 'light';
      break;
  }
  return <Badge variant={variant} className={className} data-id="element-561">
      {state}
    </Badge>;
}
export function IcpBadge({
  priority,
  className = ''
}: {
  priority: string;
  className?: string;
}) {
  let variant: BadgeProps['variant'] = 'light';
  if (priority === 'A') variant = 'success';
  if (priority === 'B') variant = 'warning';
  return <Badge variant={variant} className={`w-6 h-6 justify-center rounded-full p-0 ${className}`} data-id="element-562">
      {priority}
    </Badge>;
}
export function ScoreBadge({
  score,
  priority,
  className = ''
}: {
  score: number;
  priority: string;
  className?: string;
}) {
  let ringColor = 'border-white/20 text-growthly-muted';
  if (priority === 'A') ringColor = 'border-growthly-green text-growthly-green';
  if (priority === 'B') ringColor = 'border-growthly-amber text-growthly-amber';
  return <div className={`w-9 h-9 rounded-full border-2 flex items-center justify-center text-[13px] font-bold bg-growthly-bg ${ringColor} ${className}`} data-id="element-563">
      {score}
    </div>;
}